<template>
    <Carousel/>
</template>

<script>
import Carousel from '@/components/Carousel.vue'
  export default {
    name: 'home',
    data () {
      return {
        }
    },
    components: {
      Carousel,
    },
    methods: {
    }
  }
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/pages/Home.vue